module.exports = __webpack_public_path__ + "static/media/mts.fe0f0a0c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mts.jpeg
// module id = 59
// module chunks = 0